import React from "react";
import { FaInstagram, FaTiktok, FaXTwitter, FaEnvelope } from "react-icons/fa6";
import bgFooter from "../../assets/images/bg-footer.png";
import wedifyLogo from "../../assets/logo/wedify-logo-white.png";
import qrisLogo from "../../assets/logo/qris.png";
import ovoLogo from "../../assets/logo/ovo.png";
import danaLogo from "../../assets/logo/dana.png";
import bcaLogo from "../../assets/logo/bca.png";
import gopayLogo from "../../assets/logo/gopay.png";
import linkAjaLogo from "../../assets/logo/linkaja.png";
import shopeePayLogo from "../../assets/logo/shopeepay.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className="text-white py-10 px-4 md:px-20 bg-cover bg-center font-montserrat"
      style={{ backgroundImage: `url(${bgFooter})` }}
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Kolom 1: Tentang Wedify */}
        <div>
          <h2 className="text-xl font-semibold">Wedify</h2>
          <p className="text-sm mt-2 pr-10">
            Solusi undangan pernikahan digital tanpa cetak, tanpa ribet—lebih
            cepat, lebih hemat, dan elegan.
          </p>
          <div className="flex gap-4 mt-4">
            <FaInstagram className="w-6 h-6 cursor-pointer hover:scale-110 transition" />
            <FaTiktok className="w-6 h-6 cursor-pointer hover:scale-110 transition" />
            <FaXTwitter className="w-6 h-6 cursor-pointer hover:scale-110 transition" />
          </div>
        </div>

        {/* Kolom 2: Navigasi */}
        <div className="max-w-[150px]">
          <h2 className="text-xl font-semibold">Navigation</h2>
          <ul className="mt-2 space-y-4 text-sm">
            {[
              { name: "Home", id: "home-section" },
              { name: "Fitur", id: "features-section" },
              { name: "Tema", id: "theme-section" },
              { name: "Bundle", id: "bundle-section" },
              { name: "FAQ", id: "faq-section" },
              { name: "Testimoni", id: "testimonial-section" },
            ].map((item) => (
              <li key={item.id}>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    const target = document.getElementById(item.id);
                    if (target) {
                      target.scrollIntoView({ behavior: "smooth" });
                      window.history.pushState(
                        null,
                        "",
                        window.location.pathname
                      );
                    }
                  }}
                  className="hover:text-gray-300 transition"
                >
                  {item.name}
                </button>
              </li>
            ))}
            <li>
              <Link to="/login" className="hover:text-gray-300 transition">
                Login
              </Link>
            </li>
            <li>
              <Link to="/register" className="hover:text-gray-300 transition">
                Register
              </Link>
            </li>
          </ul>
        </div>
        {/* Kolom 3: Metode Pembayaran */}
        <div className="max-w-[180px]">
          <h2 className="text-xl font-semibold">Metode Pembayaran</h2>
          <div className="grid grid-cols-3 gap-4 mt-3">
            {[
              qrisLogo,
              gopayLogo,
              ovoLogo,
              linkAjaLogo,
              danaLogo,
              shopeePayLogo,
              bcaLogo,
            ].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt="payment-method"
                className="h-16 w-16 object-contain"
              />
            ))}
          </div>
        </div>

        {/* Kolom 4: Logo & Syarat Ketentuan */}
        <div>
          <img src={wedifyLogo} alt="Wedify Logo" className="w-24 mb-6" />
          <ul className="space-y-6 text-sm">
            <li>
              <a
                href="/terms-of-service"
                className="hover:text-gray-300 transition"
              >
                Syarat dan Ketentuan
              </a>
            </li>
            <li>
              <a href="/help" className="hover:text-gray-300 transition">
                Pusat Bantuan
              </a>
            </li>
            <li className="flex items-center gap-2 mt-2">
              <FaEnvelope className="w-5 h-5" />
              <span>wedifyofficial@gmail.com</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center text-xs mt-10 border-t border-gray-600 pt-4">
        Wedify © Copyright 2025. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
